<template>
    <DeathData/>
</template>

<script>
import { DeathData } from 'shared'

export default {
    name: 'deathData',
    components: {
        DeathData
    },
    created() {
        this.$store.commit('getDeath', {
            shares: '产业电商',
            a100: ''
        })
    }
}
</script>